/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { useEffect, useRef } from 'react';

export default function usePrevious(value, defaultValue) {
    const ref = useRef(defaultValue);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
